import { useTranslation } from "react-i18next";

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="lg:w-[40%] w-full">
            <div className="w-full aspect-[3/4] max-w-[380px] mx-auto rounded-[28px] overflow-hidden bg-accent-50">
              <img
                src="https://readdy.ai/api/search-image?query=Young%20stylish%20European%20man%20in%20his%20twenties%20with%20casual%20modern%20outfit%20holding%20a%20smartphone%20while%20standing%20against%20a%20soft%20warm%20coral%20tinted%20wall%20natural%20daylight%20streaming%20from%20the%20side%20editorial%20portrait%20photography%20style%20fresh%20and%20genuine%20expression%20clean%20minimal%20composition%20with%20warm%20cream%20and%20coral%20tones%20high%20quality%20detail&width=800&height=1067&seq=testimonial-person-v2-2026&orientation=portrait"
                alt="Comprador satisfeito com HoobuySpreadsheet"
                title="Cliente HoobuySpreadsheet"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-[60%] max-w-xl">
            <span className="text-xs font-semibold text-foreground-400 uppercase tracking-widest">
              {t("testimonial.label")}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-4 leading-tight">
              {t("testimonial.heading")}{" "}
              <span className="text-foreground-300">{t("testimonial.headingHighlight")}</span>
            </h2>
            <blockquote className="mt-8 text-base md:text-lg text-foreground-600 leading-relaxed italic border-l-4 border-primary-300 pl-5">
              &ldquo;{t("testimonial.quote")}&rdquo;
            </blockquote>
            <p className="mt-5 text-sm font-semibold text-foreground-800">
              &mdash; {t("testimonial.author")}
            </p>

            {/* Nav dots */}
            <div className="flex items-center gap-3 mt-10">
              <button className="w-10 h-10 rounded-full border border-foreground-200 flex items-center justify-center cursor-pointer hover:border-foreground-400 transition-colors" aria-label="Anterior">
                <i className="ri-arrow-left-line text-foreground-500"></i>
              </button>
              <button className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center cursor-pointer hover:bg-foreground-800 transition-colors" aria-label="Seguinte">
                <i className="ri-arrow-right-line text-background-50"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}